export default "__VITE_ASSET__LfM_JHJQ__"